export function useAssistantMessageContentHandlers(vm, { onMenu, onNotes, onReadAloud, onGood, onBad, text }) {
  const handleOpenMenu = (e) => {
    vm.setMenuAnchorEl(e.currentTarget)
    onMenu?.()
  }
  const handleCloseMenu = () => vm.setMenuAnchorEl(null)
  const handleOpenRetryMenu = (e) => vm.setRetryAnchorEl(e.currentTarget)
  const handleCloseRetryMenu = () => vm.setRetryAnchorEl(null)
  const handleAddToNotes = () => {
    handleCloseMenu()
    onNotes?.()
  }
  const handleReadAloud = () => {
    handleCloseMenu()
    if (!text || !vm.canSpeak) return
    onReadAloud?.(text)
  }
  const toggleGood = () => {
    vm.setFeedback((prev) => {
      const next = prev === 'good' ? null : 'good'
      if (next === 'good') onGood?.()
      return next
    })
  }
  const toggleBad = () => {
    vm.setFeedback((prev) => {
      const next = prev === 'bad' ? null : 'bad'
      if (next === 'bad') onBad?.()
      return next
    })
  }
  return {
    handleOpenMenu,
    handleCloseMenu,
    handleOpenRetryMenu,
    handleCloseRetryMenu,
    handleAddToNotes,
    handleReadAloud,
    toggleGood,
    toggleBad,
  }
}
